// 引用API文件
import GlobalData from './GlobalData.js'
import {Message} from 'element-ui'
import globalFunction from "./GlobalFunction";
import VueCookies from 'vue-cookies'
import Vue from "vue";

//Cookie
Vue.use(VueCookies)

// 配置API接口地址
var root = GlobalData.API_SERVER_BASE_URL;
var root_news = GlobalData.API_NEWS_SERVER_BASE_URL;
// 引用axios
var axios = require('axios')

// 自定义判断元素类型JS
function toType(obj) {
    return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}

// 参数过滤函数
function filterNull(o) {
    for (var key in o) {
        if (o[key] === null) {
            delete o[key]
        }
        if (toType(o[key]) === 'string') {
            o[key] = o[key].trim()
        } else if (toType(o[key]) === 'object') {
            o[key] = filterNull(o[key])
        } else if (toType(o[key]) === 'array') {
            o[key] = filterNull(o[key])
        }
    }
    return o
}

/*
  接口处理函数
  这个函数每个项目都是不一样的，我现在调整的是适用于
  https://cnodejs.org/api/v1 的接口，如果是其他接口
  需要根据接口的参数进行调整。参考说明文档地址：
  https://cnodejs.org/topic/5378720ed6e2d16149fa16bd
  主要是，不同的接口的成功标识和失败提示是不一致的。
  另外，不同的项目的处理方法也是不一致的，这里出错就是简单的alert
*/
function apiAxios(method, url, params, onSuccess, onFailure, onCatch) {
    //memberId = 3
    // localStorage.setItem("memberToken","j1zhishuQDbJzDoUq7p1BB36QUAWu1uRaLnl0ukYecc%3D")
    // localStorage.setItem("adminToken","itablwXlACBc0YfiQrANqfSXuH6BCdXDJ7zB6Hu9ZaI%3D")
    if (params) {
        params['memberToken'] = localStorage.getItem("memberToken")
        params['adminToken'] = localStorage.getItem("adminToken")
        params['selectLanguage'] = localStorage.getItem("selectLanguage")
        params['memberLoginToken'] = localStorage.getItem("memberLoginToken")//记住我
        params = filterNull(params)
    }

    axios({
        method: method,
        url: url,
        data: method === 'POST' || method === 'PUT' ? params : null,
        params: method === 'GET' || method === 'DELETE' ? params : null,
        baseURL: root,
        withCredentials: false
    })
    .then(function (res) {
        let data = res.data;
        changeI18n(data);
        if (data.result === "success") {
            if (onSuccess) {
                onSuccess(data)
            }
        } else {
            if (onFailure) {
                let resultCode = data.resultCode;

                if(resultCode == 1000)
                {
                    //失效后需要清空，本地存储的用户登录信息
                    localStorage.removeItem("memberName")
                    localStorage.removeItem("headImagePath")
                    localStorage.removeItem("firstLetter")
                    localStorage.removeItem("email")
                    localStorage.removeItem("memberId")
                    localStorage.removeItem("phoneNumber")
                    localStorage.removeItem("memberToken")
                    localStorage.removeItem("socketioUserToken")
                    localStorage.removeItem("memberLoginToken")

                    location.href = "/login.html";
                    return;
                }

                if(resultCode == 2000)
                {
                    location.href = "../superAdmin/login.html";
                    return;
                }

                onFailure(data)
            } else {
                window.alert('error: ' + JSON.stringify(data))
            }
        }
    })
    .catch(function (err) {
        if (onCatch) {
            onCatch()
        } else {
            // Message.error('api error, HTTP CODE: ' + err)
            console.log(err)
        }
    })
}

//请求Jpress
function apiAxiosForJpress(method, url, params, onSuccess, onFailure, onCatch) {
    if (params) {
        params['selectLanguage'] = localStorage.getItem("selectLanguage")
        params = filterNull(params)
    }

    // console.log(params)

    axios({
        method: method,
        url: url,
        data: method === 'POST' || method === 'PUT' ? params : null,
        params: method === 'GET' || method === 'DELETE' ? params : null,
        baseURL: root_news,
        withCredentials: false
    })
    .then(function (res) {
        // console.info(res)
        if (res.status == 200) {
            let result = res.data
            if (result.state && result.state == 'fail') {
                // console.log(result.message)
                onFailure(result)
            }
            else
            {
                onSuccess(result)
            }
        }
        else
        {
            console.log("数据请求失败，错误代码："+res.status)
        }


    })
    .catch(function (err) {
        if (onCatch) {
            onCatch()
        } else {
            // Message.error('api error, HTTP CODE: ' + err)
            console.log(err)
        }
    })
}

function changeI18n(data) {
    let info = data.info;
    if (info != undefined) {
        var resultInfo = ""
        let languageType = localStorage.getItem("selectLanguage")
        switch (info) {
            case "操作成功": {
                resultInfo = global.CN_EN.operateSuccess[languageType];
                break
            }
            case "操作失败": {
                resultInfo = global.CN_EN.operateFail[languageType];
                break
            }
            default: {
                resultInfo = info
                break
            }
        }
        data.info = resultInfo
    }
}

function defaultApi(method, url, params, onSuccess, showSuccess = false, onFailure, showLoading = false, loadingMsg = "", onCatch) {
    var loadingInstance = undefined
    if (showLoading) {
        loadingInstance = globalFunction.showLoading(loadingMsg)
    }
    apiAxios(method, url, params, (data) => {
        if (showLoading) {
            globalFunction.dismissLoading(loadingInstance)
        }
        if (showSuccess) {
            Message.success(data.info)
        }
        if (onSuccess) {
            onSuccess(data)
        }
    }, (data) => {
        // console.log('defaultApi onFailure data is '+data)
        Message.error(data.info)
        if (onFailure != undefined) {
            onFailure(data)
        }
        if (showLoading) {
            globalFunction.dismissLoading(loadingInstance)
        }
    }, (err) => {
        console.log(err)
        if (showLoading) {
            globalFunction.dismissLoading(loadingInstance)
        }
    })
}

// 返回在vue模板中的调用接口
export default {
    get: function (url, params, onSuccess, onFailure, onCatch) {
        return apiAxios('GET', url, params, onSuccess, onFailure, onCatch)
    },
    getForJpress: function (url, params, onSuccess, onFailure, onCatch) {
        return apiAxiosForJpress('GET', url, params, onSuccess, onFailure, onCatch)
    },
    post: function (url, params, onSuccess, onFailure, onCatch) {
        return apiAxios('POST', url, params, onSuccess, onFailure, onCatch)
    },
    postForJpress: function (url, params, onSuccess, onFailure, onCatch) {
        return apiAxiosForJpress('POST', url, params, onSuccess, onFailure, onCatch)
    },
    put: function (url, params, onSuccess, onFailure, onCatch) {
        return apiAxios('PUT', url, params, onSuccess, onFailure, onCatch)
    },
    delete: function (url, params, onSuccess, onFailure, onCatch) {
        return apiAxios('DELETE', url, params, onSuccess, onFailure, onCatch)
    },
    /**
     * 默认的Post方法，主要对post方法进行了弹窗封装
     * @param url String，请求的链接URL
     * @param params Object，请求参数
     * @param onSuccess Function，当请求成功时的回调
     * @param showSuccess Boolean，是否显示操作成功弹窗
     * @param onFailure Function，当出错时的回调
     * @param showLoading Boolean，是否显示加载弹窗
     * @param loadingMsg String，加载时的提示语
     * @param onCatch Function，当请求框架出错时的回调（基本用不着）
     */
    defaultPost: function (url, params, onSuccess, showSuccess, onFailure, showLoading, loadingMsg, onCatch) {
        return defaultApi('POST', url, params, onSuccess, showSuccess, onFailure, showLoading, loadingMsg, onCatch)
    },
    defaultGet: function (url, params, onSuccess, showSuccess, onFailure, showLoading, loadingMsg, onCatch) {
        return defaultApi('GET', url, params, onSuccess, showSuccess, onFailure, showLoading, loadingMsg, onCatch)
    },
    defaultDelete: function (url, params, onSuccess, showSuccess, onFailure, showLoading, loadingMsg, onCatch) {
        return defaultApi('DELETE', url, params, onSuccess, showSuccess, onFailure, showLoading, loadingMsg, onCatch)
    },
    defaultPut: function (url, params, onSuccess, showSuccess, onFailure, showLoading, loadingMsg, onCatch) {
        return defaultApi('PUT', url, params, onSuccess, showSuccess, onFailure, showLoading, loadingMsg, onCatch)
    },
}

// //百度统计
// var _hmt = _hmt || [];
// (function() {
//     var hm = document.createElement("script");
//     hm.src = "https://hm.baidu.com/hm.js?eec2bdcddf67133df08e36d3175ab577";
//     var s = document.getElementsByTagName("script")[0];
//     s.parentNode.insertBefore(hm, s);
// })();
